import PropTypes from 'prop-types';

export const aggregationShape = PropTypes.shape({

});

export const groundTruthShape = PropTypes.shape({
  minimumScore: PropTypes.number.isRequired,
});

export const translatableShape = PropTypes.shape({
  uuid: PropTypes.string,
  text: PropTypes.string,
});

export const invoiceShape = PropTypes.shape({
  id: PropTypes.number,
  orderNumber: PropTypes.string,
  invoiceNumber: PropTypes.string,
});

export const registrationDataShape = PropTypes.shape({

});

// since the payload has the question uuids as keys, we'd need a custom validator
// TODO: THIS TYPE IS OBSOLTE. INSTEAD USE: surveySubmissionShape
export const submissionPayloadShape = PropTypes.shape({
  version: PropTypes.number,
});

export const languagesShape = PropTypes.arrayOf(PropTypes.shape({
  displayValue: PropTypes.string,
  value: PropTypes.string,
}));

// TODO: also remove this one - not used in any of active views
export const submissionShape = PropTypes.shape({
  lastUpdatedAt: PropTypes.string.isRequired,
  payload: submissionPayloadShape.isRequired,
  feedbackProvided: PropTypes.bool,
});

export const quipUserShape = PropTypes.shape({
  title: PropTypes.string,
  position: PropTypes.string,
  firstname: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
  activated: PropTypes.bool,
  registrationData: registrationDataShape,
});

export const instituteShape = PropTypes.shape({
  name: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  housenumber: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  fax: PropTypes.string,
  street: PropTypes.string,
  additionalAddress: PropTypes.string,
  zip: PropTypes.string,
  isCompany: PropTypes.bool,
  instituteID: PropTypes.string,
  taxID: PropTypes.string,
  hospitalName: PropTypes.string,
  customClearanceUser: PropTypes.string,
  customClearanceContact: PropTypes.string,
  customClearanceEmail: PropTypes.string,
});

export const trialShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  samples: PropTypes.string.isRequired,
  participants: PropTypes.number.isRequired,
  parentTrialId: PropTypes.number,
});

export const enrollmentShape = PropTypes.shape({
  createdAt: PropTypes.string.isRequired,
  paymentReceivedAt: PropTypes.string,
  trial: trialShape,
  quipUser: quipUserShape,
  status: PropTypes.string.isRequired,
});

export const userFormGroupShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  firstname: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  commLanguage: PropTypes.string.isRequired,
});

export const openQuestionAnswerShape = PropTypes.shape({
  answer: PropTypes.string.isRequired,
  detailQuestion: translatableShape,
});

export const openQuestionOptionShape = PropTypes.shape({
  answer: translatableShape,
  detailQuestion: translatableShape,
});

export const openQuestionShape = PropTypes.shape({
  type: PropTypes.oneOf(['single', 'multiple', 'freeText', 'MultipleChoice']),
  question: translatableShape,
  options: PropTypes.arrayOf(openQuestionOptionShape),
  required: PropTypes.bool,
});

// TODO: REMOVE: USED BY SURVEYMATRIX (outdated)
export const sectionAnswerShape = PropTypes.shape({
  oneOff: PropTypes.shape({
    options: PropTypes.arrayOf(translatableShape),
  }).isRequired,
  additional: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['IntegerPercentage']),
      option: translatableShape,
      enableIf: PropTypes.shape({
        notEqual: PropTypes.string.isRequired,
      }),
    }),
  ),
});

export const sectionPayloadShape = PropTypes.shape({
  id: PropTypes.string, // TODO: really?
  numCases: PropTypes.number,
  questions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    question: translatableShape,
  })),
  sampleIds: PropTypes.arrayOf(PropTypes.string),
});

export const submissionAnswerShape = PropTypes.shape({
  type: PropTypes.string,
  answer: PropTypes.string,
});

export const submissionAnswersArray = PropTypes.shape({
  answers: PropTypes.arrayOf(submissionAnswerShape),
});

export const sectionSubmissionShape = PropTypes.shape({
  questions: PropTypes.objectOf(submissionAnswersArray), // <uuid>: {answers: []}
  sampleIds: PropTypes.arrayOf(PropTypes.string),
});

export const surveyPayloadShape = PropTypes.shape({
  version: PropTypes.number,
  openQuestions: PropTypes.arrayOf(openQuestionShape),
  sections: PropTypes.arrayOf(sectionPayloadShape),
  showComments: PropTypes.bool,
});

export const surveySubmissionShape = PropTypes.shape({
  version: PropTypes.number,
  openQuestions: PropTypes.arrayOf(openQuestionShape),
  sections: PropTypes.arrayOf(sectionSubmissionShape),
});

export const oneOfShape = PropTypes.shape({
  question: translatableShape,
  options: PropTypes.arrayOf(translatableShape),
  numCases: PropTypes.number,
  startCase: PropTypes.number,
  onSamplePayloadChanged: PropTypes.func,
  answerPayload: submissionAnswersArray,
  getSubmissionAnswer: PropTypes.func,
  defaultOption: translatableShape,
});

export const integerPercentageShape = PropTypes.shape({
  question: translatableShape,
  disableIf: PropTypes.shape({
    question: PropTypes.string,
    operation: PropTypes.string,
    value: PropTypes.string,
  }),
  numCases: PropTypes.number,
  startCase: PropTypes.number,
  onSamplePayloadChanged: PropTypes.func,
  answerPayload: submissionAnswersArray,
  getSubmissionAnswer: PropTypes.func,
});

export const arbitraryStringShape = PropTypes.shape({
  question: translatableShape,
  disableIf: PropTypes.shape({
    question: PropTypes.string,
    operation: PropTypes.string,
    value: PropTypes.string,
  }),
  numCases: PropTypes.number,
  startCase: PropTypes.number,
  onSamplePayloadChanged: PropTypes.func,
  answerPayload: submissionAnswersArray,
  getSubmissionAnswer: PropTypes.func,
});

export const surveyShape = PropTypes.shape({
  id: PropTypes.number,
  payload: surveyPayloadShape,
});

export const fieldErrorShape = PropTypes.shape({
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
});

export const errorMessageShape = PropTypes.shape({
  errorMessage: PropTypes.object,
});

export const evaluationSectionShape = PropTypes.shape({
  questions: PropTypes.objectOf(PropTypes.shape({
    answersBySamples: PropTypes.arrayOf(PropTypes.shape({
      totalAnswers: PropTypes.number,
    })),
  })),
});

export const scoresShape = PropTypes.shape({ [PropTypes.string]: PropTypes.number });

export const evaluationOrderDataShape = PropTypes.shape({
  certText1: PropTypes.string.isRequired,
  certText2: PropTypes.string.isRequired,
  certText3: PropTypes.string.isRequired,
});

export const reviewSubmissionShape = PropTypes.shape({
  payload: PropTypes.shape({
    sections:
      PropTypes.arrayOf(PropTypes.shape({
        questions: PropTypes.objectOf(
          PropTypes.shape({
            answers: PropTypes.arrayOf(arbitraryStringShape),
          }),
        ),
      })),
  }),
});
